import DOMPurify from "dompurify";
import React from "react";
import { configService } from "../../services";

export const Footer: React.FC = () => {

  const config = configService.current();

  const safesmallPrint = DOMPurify.sanitize(config.footerProps.smallPrint);

  const appId = configService.current().theme.Id;
  // let appName = configService.current().applicationTitle;


  if (["zebratechnologies"].includes(appId as string)) {
    return (
      <footer>
        <div className="container">
          <p className='m-0 font-smallprint' dangerouslySetInnerHTML={{ __html: safesmallPrint }}></p>
          <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.helpUrl}>{config.footerProps.helpText}</a>
          {config.footerProps.cookiePolicyUrl && <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.cookiePolicyUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.cookiePolicyText}</a>}
          {/* {config.footerProps.termsUrl && <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.termsUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.termsText}</a>} */}
          <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.privacyUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.privacyText}</a>
        </div>
      </footer>
    )
  }

  if (["ricoh-rewards"].includes(appId as string)) {
    return (
      <footer>
        <div className="container d-flex flex-column flex-md-row justify-content-center align-items-center gap-5">
          {/* <p className='m-0 font-smallprint' dangerouslySetInnerHTML={{ __html: safesmallPrint }}></p> */}
          {/* <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.helpUrl}>{config.footerProps.helpText}</a> */}
          {/* {config.footerProps.cookiePolicyUrl && <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.cookiePolicyUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.cookiePolicyText}</a>} */}
          {/* {config.footerProps.termsUrl && <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.termsUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.termsText}</a>} */}
          {/* <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.privacyUrl} target="_blank" rel="noopener noreferrer">{config.footerProps.privacyText}</a> */}
        </div>
      </footer>
    )
  }


  return (
    <footer className='d-flex p-x-1 justify-content-between p-y-05'>
      <div>
        <p className='m-0 font-smallprint' dangerouslySetInnerHTML={{ __html: safesmallPrint }}></p>
      </div>
      <div>
        <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.helpUrl}>{config.footerProps.helpText}</a>
      </div>
      {(config.footerProps.cookiePolicyUrl) ?
        <div>
          <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.cookiePolicyUrl} target="_blank">{config.footerProps.cookiePolicyText}</a>
        </div> : <></>
      }
      {(config.footerProps.termsUrl) ?
        <div>
          <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.termsUrl} target="_blank">{config.footerProps.termsText}</a>
        </div> : <></>
      }
      <div>
        <a className='m-0 font-smallprint color-text text-decoration-none' href={config.footerProps.privacyUrl} target="_blank">{config.footerProps.privacyText}</a>
      </div>
    </footer>
  )
}